<div class="vd-info">
    <div class="vd-eyebrow">Video album<span *ngIf="networkName"> · {{ networkName }}</span></div>
    <h1 class="vd-title">{{ title }}</h1>
    <div class="vd-meta" *ngIf="metaLine.length">
        <span *ngFor="let part of metaLine; let last = last">{{ part }}<span *ngIf="!last" class="vd-dot">·</span></span>
    </div>

    <div class="vd-actions" *ngIf="actions?.showActions">
        <button type="button" class="vd-btn vd-btn-accent vd-btn-lg" *ngIf="actions.showPlay" [disabled]="actions.playDisabled" (click)="play.emit()">
            <app-vd-icon name="play"></app-vd-icon> {{ playLabel }}
        </button>
        <span class="vd-sub-chip" *ngIf="actions.subscriptionChip" [class.is-on]="actions.subscriptionChip === 'Subscribed'"
            [matTooltip]="actions.subscriptionChip === 'Subscribed' ? 'Included in your subscription' : 'Needs a subscription to watch'" matTooltipPosition="above">
            <app-vd-icon name="subscribe"></app-vd-icon> {{ actions.subscriptionChip }}
        </span>
        <button type="button" class="vd-btn vd-btn-accent vd-btn-lg" *ngIf="actions.showAlbumSubscribe" (click)="subscribeAlbum.emit()">
            <app-vd-icon name="subscribe"></app-vd-icon> Subscribe
        </button>
        <button type="button" class="vd-btn vd-btn-accent vd-btn-lg" *ngIf="actions.showAlbumBuy" (click)="buyAlbum.emit()">
            <app-vd-icon name="buy"></app-vd-icon> Buy album
        </button>
        <button type="button" class="vd-btn vd-btn-ghost vd-btn-lg" *ngIf="actions.tipKind" (click)="tip.emit()">
            <app-vd-icon [name]="actions.tipKind === 'tip' ? 'tip' : 'donate'"></app-vd-icon> {{ actions.tipKind === 'tip' ? 'Tip the creator' : 'Donate' }}
        </button>
        <button type="button" class="vd-btn vd-btn-ghost vd-btn-lg" *ngIf="actions.showPolls" (click)="polls.emit()">
            <app-vd-icon name="polls"></app-vd-icon> Polls
        </button>
    </div>

    <div class="vd-countdown" *ngIf="countdown">
        <div class="vd-countdown-label">Sale starts in</div>
        <div class="vd-countdown-units">
            <div><strong>{{ countdown.days }}</strong><span>{{ countdown.days == 1 ? 'Day' : 'Days' }}</span></div>
            <div><strong>{{ countdown.hours }}</strong><span>{{ countdown.hours == 1 ? 'Hour' : 'Hours' }}</span></div>
            <div><strong>{{ countdown.minutes }}</strong><span>{{ countdown.minutes == 1 ? 'Minute' : 'Minutes' }}</span></div>
            <div><strong>{{ countdown.seconds }}</strong><span>Seconds</span></div>
        </div>
    </div>

    <div class="vd-desc" *ngIf="description" [class.is-open]="descriptionOpen" [innerHTML]="description"></div>
    <button type="button" class="vd-link" *ngIf="descriptionIsLong" (click)="descriptionOpen = !descriptionOpen">{{ descriptionOpen ? 'Show less' : 'Show more' }}</button>
</div>
